export function alertSound() {
  const alertAudio = new Audio("/audio/warning-signal.mp3");
  alertAudio.play();
}
